
import * as React from 'react';

import Button from '../../Button';
import { Modal } from '../../Modal';
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes'
import './BlankCreatorModal.css';
import { IBlank } from 'src/infrastructure/interfaces';
import { contentImagesRelativePath } from 'src/constants';

export interface BlankCreatorProps {
  blank?: IBlank;
  show: any;
  onClose: any;
  updateBlank(blank: IBlank, imageFormData?: FormData): void;
  createBlank(blankName: string, blankURL: string, imageFormData: FormData): void;
}

export interface BlankCreatorState {
  hasRequiredFields: boolean;
  imageFormData?: FormData;
  blankName: string;
  blankURL: string
}

export default class BlankCreatorModal extends React.Component<BlankCreatorProps, BlankCreatorState> {

  constructor(props: BlankCreatorProps) {
    super(props);

    this.state = {
      imageFormData: undefined,
      hasRequiredFields: false,
      blankName: (props.blank) ? props.blank.title : '',
      blankURL: (props.blank) ? props.blank.url : ''
    };
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.blank) {
      var newBlankName = (nextProps.blank.title) ? nextProps.blank.title : '';
      var newBlankURL = (nextProps.blank.url) ? nextProps.blank.url : '';
      this.setState({
          blankName: newBlankName,
          blankURL: newBlankURL,
          hasRequiredFields: newBlankName.length > 0
      });
    }
  }

  onSubmit() {
    if (this.props.blank && this.props.blank.id) {
      const newBlank = { ...this.props.blank, title: this.state.blankName, url: this.state.blankURL};
      if (this.props.updateBlank) {
          this.props.updateBlank(newBlank, this.state.imageFormData);
      }
    } else {
        if (!this.state.imageFormData) {
            return;
        }
        if (this.props.createBlank) {
          this.props.createBlank(this.state.blankName, this.state.blankURL, this.state.imageFormData);
        }
    }
  }

  closeModal() {
      this.setState({
        blankName: '',
        blankURL: '',
      });
      this.props.onClose();
  }

  handleImageChange(selectorFiles: FileList | null) {
    if (selectorFiles != null) {
      for (var key in selectorFiles) {
        if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
          var imageFormData = new FormData();
          imageFormData.set(ImageFileTypes.BLANK, selectorFiles[key]);
          this.setState({imageFormData, hasRequiredFields: true},);
          break;
        }
      }
    }
  }

  handleProductNameChange(newBlankName: string) {
    this.setState({
      blankName: newBlankName
    }, () => this.hasValidFields());
  }
  
  handleProductURLChange(newBlankURL: string) {
    this.setState({
      blankURL: newBlankURL
    }, () => this.hasValidFields());
  }

  hasValidFields() {
    const hasValidText = ((this.state.blankName.length > 1) && (this.state.blankURL.length < 256));
    const hasValidImages = (this.props.blank)
        ? true
        : (
            (this.state.imageFormData != undefined)
            && (this.state.imageFormData.get(ImageFileTypes.BLANK) != null)
          )
    this.setState({ hasRequiredFields: (hasValidText && hasValidImages) });
  }

  render() {

    return (
        <Modal show={this.props.show}
          onClose={() => {this.closeModal();}}
        >
            <Modal.Header>
                <Modal.Title>
                    <h5>
                      {this.props.blank ? this.props.blank.title : 'Upload Fullscreen Catalog Image'}
                    </h5>
                    (JPEGs, 8.5"x11")
                </Modal.Title>
                <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
            </Modal.Header>
            <Modal.Body>

              <div className="blankContainer">
                <div className="blankInputContainer">
                  <div>
                    <label>
                      <b>Product Name:</b>
                    </label>
                    <input
                        placeholder="Product Name"
                        maxLength={100}
                        value={this.state.blankName}
                        onChange={e => {
                            this.handleProductNameChange(e.target.value);
                        } }/>
                    </div>
                </div>

                <div className="blankInputContainer">
                  <div>
                    <label>
                      <b>Product URL:</b>
                    </label>
                    <input
                        placeholder="Product URL"
                        maxLength={256}
                        value={this.state.blankURL}
                        onChange={e => {
                            this.handleProductURLChange(e.target.value);
                        } }/>
                    </div>
                </div>

                <div className="blankInputContainer">
                  <label>
                      <b>Image</b>
                  </label>
                  {
                    (this.props.blank) ? 
                    <img src={contentImagesRelativePath + this.props.blank.src} />
                    : null
                  }
                  <input type="file" className="filepond" onChange={(e) => this.handleImageChange(e.target.files)} />
                </div>
              </div>

            </Modal.Body>
            <Modal.Footer>
                <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                    Cancel
                </Button>
                <Button
                    bsClass="primary"
                    disabled={!this.state.hasRequiredFields}
                    onClick={() => {
                      this.onSubmit();
                    }}
                >
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/BlankCreatorModal/BlankCreatorModal.tsx